import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "content",
  style: {"padding":"2rem 0"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Welcome to the")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Protractor Companion App")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Protractor works to bring leading edge technology to automotive aftermarket repair shops and tire stores.", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "VIN scanner"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Enables you to capture a picture of the VIN and save it directly to the work order.")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("i", null, "Planned features"),
  /*#__PURE__*/_createTextVNode(" - Digital Vehicle Inspection, Reporting, Time Clock, to name a few.")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "Not a Protractor user?", -1)
const _hoisted_9 = {
  href: "https://www.protractorsoftware.com/contact/",
  target: "_blank"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", null, "Want to learn more?", -1)
const _hoisted_11 = {
  href: "https://www.protractorsoftware.com",
  target: "_blank"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", null, "Already a Protractor user?", -1)
const _hoisted_13 = {
  href: "https://www.protractorsoftware.com/contact/",
  target: "_blank"
}

import { useAuth0 } from "@auth0/auth0-vue";
import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";

import StoreHome from "./StoreHome.vue";
import EnterpriseHome from "./EnterpriseHome.vue";
import ApiService from "@/service/api.service";


export default /*#__PURE__*/_defineComponent({
  name: 'HomeContent',
  setup(__props) {

const { isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();
const enterprisestoreerror = ref(false);
const store = useStore();
onMounted(async () => {
  if (isAuthenticated.value === true) {
    await getUserInfo();
  }
})

// watch isLoading and isAuthenticated object to handle auth0 successful login - for initial login
const stop = watch([isLoading, isAuthenticated], async ([loading, auth]) => {
  if (!loading && auth) {
    await getUserInfo();
    stop();
  }
});

const getUserInfo = async() => {
  const accessToken = await getAccessTokenSilently();
  await ApiService.getUserInfo(accessToken);
}

return (_ctx: any,_cache: any) => {
  const _component_ErrorModal = _resolveComponent("ErrorModal")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_EnterpriseStoreError = _resolveComponent("EnterpriseStoreError")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ErrorModal),
    (!_unref(isAuthenticated))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Card, null, {
            icon: _withCtx(() => []),
            title: _withCtx(() => [
              _hoisted_2,
              _hoisted_3,
              _hoisted_4
            ]),
            content: _withCtx(() => [
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("a", _hoisted_9, [
                _createVNode(_component_Button, {
                  label: "Book a Demo",
                  class: "p-button-rounded color: btn-primary",
                  icon: "pi pi-arrow-right",
                  iconPos: "right"
                })
              ]),
              _hoisted_10,
              _createElementVNode("a", _hoisted_11, [
                _createVNode(_component_Button, {
                  label: "Visit Protractor.com",
                  class: "p-button-rounded btn-primary",
                  icon: "pi pi-arrow-right",
                  iconPos: "right"
                })
              ]),
              _hoisted_12,
              _createElementVNode("a", _hoisted_13, [
                _createVNode(_component_Button, {
                  label: "Request a Login",
                  class: "p-button-rounded btn-primary",
                  icon: "pi pi-arrow-right",
                  iconPos: "right"
                })
              ])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    ((_unref(store).state.role && !['EnterpriseAdmin', 'SupportAdmin'].includes(_unref(store).state.role)) ||
    _unref(store).state.isStoreLogin)
      ? (_openBlock(), _createBlock(StoreHome, { key: 1 }))
      : _createCommentVNode("", true),
    (_unref(store).state.role === 'EnterpriseAdmin' && !_unref(store).state.isStoreLogin)
      ? (_openBlock(), _createBlock(EnterpriseHome, { key: 2 }))
      : _createCommentVNode("", true),
    (_unref(isAuthenticated) && enterprisestoreerror.value)
      ? (_openBlock(), _createBlock(_component_EnterpriseStoreError, { key: 3 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})